import { useTheme } from '@chakra-ui/react';

import Flex from '~/common/components/Flex';

import { useQuestionLibraryEventEmitter } from '../store/questionLibraryStore';
import { useConditionsEvaluator } from '../utils/useConditionsEvaluator';
import AddIconButton from './buttons/AddIconButton';
import DeleteIconButton from './buttons/DeleteIconButton';
import QuestionLibraryButton from './buttons/QuestionLibraryButton';
import QuestionResolutionWrapper from './utilityComponents/QuestionResolutionWrapper';

type ActionButtonProps = {
  component?: any;
};

export default function ActionButton({
  component,
}: Readonly<ActionButtonProps>) {
  const {
    label,
    eventName,
    buttonType,
    align = 'left',
    conditions = {},
    hasBottomBorder = true,
    resolutions = [],
    padding = '0 0.5rem 0.5rem 0',
  } = component;
  const { isVisible, isDisabled } = useConditionsEvaluator(conditions);
  const eventEmitter = useQuestionLibraryEventEmitter();
  const justifyMap = {
    left: 'flex-start',
    right: 'flex-end',
    center: 'center',
  };

  const handleClick = () => eventEmitter.emit(eventName);

  return (
    <QuestionResolutionWrapper
      resolutions={resolutions}
      hasBottomBorder={hasBottomBorder}
      isVisible={isVisible}
      padding={padding}
    >
      <Flex justifyContent={justifyMap[align]} width={'100%'}>
        <Button
          buttonType={buttonType}
          handleClick={handleClick}
          label={label}
          isDisabled={isDisabled}
        />
      </Flex>
    </QuestionResolutionWrapper>
  );
}

type ButtonType = 'add' | 'delete' | 'primary';

type ButtonProps = {
  buttonType?: ButtonType;
  handleClick?: (...args: any[]) => any;
  label?: string;
  isDisabled?: boolean;
};

function Button({
  buttonType,
  handleClick,
  label,
  isDisabled,
}: Readonly<ButtonProps>) {
  const theme = useTheme();
  switch (buttonType) {
    case 'add':
      return (
        <AddIconButton
          handleClick={handleClick}
          label={label}
          isDisabled={isDisabled}
        />
      );
    case 'delete':
      return (
        <DeleteIconButton
          onClick={handleClick}
          label={label}
          isDisabled={isDisabled}
        />
      );
    case 'primary':
      return (
        <QuestionLibraryButton
          handleClick={handleClick}
          backgroundColor={theme.colors.blue[600]}
          fontColor={theme.colors.white}
          label={label}
          isDisabled={isDisabled}
        />
      );
    default:
      return (
        <QuestionLibraryButton
          handleClick={handleClick}
          label={label}
          isDisabled={isDisabled}
        />
      );
  }
}
